import { Injectable } from '@angular/core';
import {VirginStructureLike} from '../models/vesta-virgin-structure.model';
import {VestaViewUpdateLike} from '../models/vesta-view-update.model';
import {
  ConfigurationVestaLike,
  PlacementConfigurationLike, PlacementTypeLike,
  SelectedMaterialColorLike
} from '../models/vesta-placement.model';
import {VestaAnnotationUpdateLike} from '../models/vesta-annotation.model';
import {VestaConfiguration} from '../models/vesta-configuration.model';


@Injectable({ providedIn: 'root' })
export class VestaMapperService {
  toSetRemoveFromViewUpdate(payload: VestaViewUpdateLike): VestaConfiguration | null {
    const set: VestaConfiguration['set'] = [];
    const hasConfigurations = Array.isArray(payload?.configurations) && payload!.configurations!.length > 0;
    const hasSingleConfiguration = !!payload?.configuration;
    if (hasConfigurations && !payload?.configuration) {
      const placements = payload.configurations as PlacementConfigurationLike[];
      this.collectFinalConfigurationUpdate(placements, set);
      return set.length ? { set } : null;
    }
    if (hasSingleConfiguration) {
      this.collectInViewUpdate(payload.configuration!, payload.selectedMaterialColor ?? null, set);
      return set.length ? { set } : null;
    }
    if (hasConfigurations) {
      const list = payload.configurations as Array<{ vestaExternalId?: string | null }>;
      return { set };
    }
    return null;
  }

  private collectFinalConfigurationUpdate(placements: PlacementConfigurationLike[], setOut: VestaConfiguration['set']): void {
    for (const placement of placements ?? []) {
      const cfg = placement?.configuration ?? null;
      if (!cfg) continue;
      if (this.isSingle(cfg.placementType)) {
        const item = this.buildSetItem(
          cfg.vestaExternalId,
          placement?.selectedMaterialColor ?? null
        );
      } else if (this.isGroup(cfg.placementType)) {
        for (const child of cfg.placementList ?? []) {
          const item = this.buildSetItem(
            child?.vestaExternalId,
            placement?.selectedMaterialColor ?? null
          );
        }
      }
    }
  }

  private collectInViewUpdate(
    cfg: ConfigurationVestaLike,
    selected: SelectedMaterialColorLike | null,
    setOut: VestaConfiguration['set']
  ): void {
    if (this.isGroup(cfg?.placementType) && (cfg?.placementList?.length ?? 0) > 0) {
      for (const child of cfg.placementList ?? []) {
        const item = this.buildSetItem(child?.vestaExternalId, selected);
      }
      return;
    }

    if (this.isSingle(cfg?.placementType)) {
      const item = this.buildSetItem(cfg?.vestaExternalId, selected);
    }
  }

  private buildSetItem(vestaExternalId?: string | null, selected?: SelectedMaterialColorLike | null): VestaConfiguration['set'] | null {
    if (!vestaExternalId) return null;
    const materialCode = selected?.material?.vestaCode ?? null;
    const colorCode = selected?.color?.vestaCode ?? null;
    if (!colorCode && !materialCode) return null;
    const second = materialCode ? materialCode : colorCode!;
    const third = colorCode ?? second;
    return null //[vestaExternalId, second, third].join('-');
  }

  private isSingle(t: PlacementTypeLike | undefined): boolean {
    if (typeof t === 'string') return t.toUpperCase() === 'SINGLE';
    return false;
  }

  private isGroup(t: PlacementTypeLike | undefined): boolean {
    if (typeof t === 'string') return t.toUpperCase() === 'GROUP';
    return false;
  }
}
